// <Toast> — single toast card rendered by ToastProvider.
//
// Per DESIGN.md §7.6: request ID MUST render in a mono tail, e.g.
// "Reconcile failed for raghuvc · reqID 8f3a…".

import type { ToastItem } from "./toast-types";

export interface ToastProps {
  toast: ToastItem;
  onDismiss: () => void;
}

function truncateReqId(id: string): string {
  if (id.length <= 8) return id;
  return `${id.slice(0, 4)}…`;
}

export function Toast({ toast, onDismiss }: ToastProps): JSX.Element {
  const isDanger = toast.tone === "danger";
  return (
    <div
      className={`rb-toast rb-toast--${toast.tone}`}
      role={isDanger ? "alert" : "status"}
    >
      <div className="rb-toast__body">
        <div className="rb-toast__title">{toast.title}</div>
        {toast.description && (
          <div className="rb-toast__desc">{toast.description}</div>
        )}
        {toast.requestId && (
          <div className="rb-toast__req">
            <span aria-hidden="true"> · </span>
            <span className="rb-toast__req-label">reqID </span>
            <code className="rb-toast__req-id">
              {truncateReqId(toast.requestId)}
            </code>
          </div>
        )}
      </div>
      <button
        type="button"
        className="rb-toast__dismiss"
        onClick={onDismiss}
        aria-label="Dismiss notification"
      >
        ×
      </button>
    </div>
  );
}
